import React from "react";
import Icon from "components/Icon";
import OptionsBtn from "components/OptionsButton";
import defaultPic from "../../../assets/images/default_profile_image.jpeg";
import Button from '@material-ui/core/Button';


const Header = ({ user, openProfileSidebar, openSearchSidebar }) => {
	const statusMapping = {null: 'All', 1: 'Open', 2: 'Pending', 3: 'Closed'};
	const userStatus = statusMapping[user.botStatus];

	return (
		<header className="header chat__header">
			<div className="chat__avatar-wrapper" onClick={openProfileSidebar}>
				<img src={user?.profile_picture ? user?.profile_picture : defaultPic} alt={user?.name} className="avatar" />
			</div>

			<div className="chat__contact-wrapper" onClick={openProfileSidebar}>
			<h2 className="chat__contact-name"> {user.name}  </h2>
				<p className="chat__contact-desc">
					{' +' +user.phone}
				</p>
			</div>
			<div className="chat__actions">
				<Button variant="outlined" className="chat__action chat__action--status" aria-label="User Status">
					{userStatus}
				</Button>
				<button
					className="chat__action"
					aria-label="Search"
					onClick={openSearchSidebar}
				>
					<Icon
						id="search"
						className="chat__action-icon chat__action-icon--search"
					/>
				</button>
				<OptionsBtn
					className="chat__action"
					ariaLabel="Menu"
					iconId="menu"
					iconClassName="chat__action-icon"
					options={[
						"Contact Info",
						"Select Messages",
						"Mute notifications",
						"Clear messages",
						"Delete chat",
					]}
				/>
				{/* Adding the new status button */}
		
			</div>
		</header>
	);
};

export default Header;
